<template>
    <mm-select :options="options" v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>

export default{
	
	data(){
		let options = [
			{
				value:'deducted',
				label:'Deducted',
				class:'status-deducted'
			},
			{
				value:'processing',
				label:'Processing',
				class:'status-processing'
			},
			{
				value:'cover',
				label:'Cover',
				class:'status-confirm'
			},
			{
				value:'hold on',
				label:'Hold On',
				class:'status-holdon'
			},
			{
				value:'confirm',
				label:'Confirm',
				class:'status-confirm'
			},
			{
				value:'confirmdelay',
				label:'Confirm>delay',
				class:'status-confirm'
			},
			{
				value:'notrunning',
				label:'Not Running',
				class:'status-deducted'
			},
		];
		if(!this.isChannel){
			options.splice(2,1);
		}
		return {
			options,
		}
	},
	props:{
		value:{},
		isChannel:Boolean,
	}
}
</script>